import { render, staticRenderFns } from "./switchmodel.vue?vue&type=template&id=601ef9ce&"
import script from "./switchmodel.vue?vue&type=script&lang=ts&"
export * from "./switchmodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "switchmodel.vue"
export default component.exports